import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function DomainRedirect() {
  const location = useLocation();

  useEffect(() => {
    const hostname = window.location.hostname;
    const pathname = location.pathname;
    
    console.log('[DomainRedirect] Current hostname:', hostname);
    console.log('[DomainRedirect] Current pathname:', pathname);
    
    // Check if user is on คอร์สดี.com custom domain
    // Punycode: xn--42c6a5b2an5cxj.com
    const isCoursedeeDomain = hostname === 'aiforyou.web.app' ||
                            hostname === 'www.aiforyou.web.app';
    
    console.log('[DomainRedirect] Is Coursedee domain?', isCoursedeeDomain);
    
    // If on Coursedee domain and trying to access /admin, redirect to edumi.co
    if (isCoursedeeDomain && pathname.startsWith('/admin')) {
      const newUrl = `https://coursedee.web.app${pathname}${location.search}${location.hash}`;
      console.log('[DomainRedirect] Redirecting to edumi.co:', newUrl);
      window.location.href = newUrl;
      return;
    }
    
    // If on Coursedee domain and at root or /v1 or /v2, show CoursedeeLanding
    if (isCoursedeeDomain && (pathname === '/' || pathname === '/v1' || pathname === '/v2' || pathname === '/V1' || pathname === '/V2')) {
      console.log('[DomainRedirect] Coursedee domain detected, CoursedeeLanding will be shown');
      // Let the routing handle it naturally
    }
  }, [location]);

  return null;
}
